import { render, staticRenderFns } from "./dataPegawai.vue?vue&type=template&id=b3c639a2&"
import script from "./dataPegawai.vue?vue&type=script&lang=js&"
export * from "./dataPegawai.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QCardSection,QInput,QBtn,QTooltip,QSeparator,QBtnGroup,QPagination,QDialog,QFile,QIcon,QCardActions,QImg,ClosePopup} from 'quasar'
component.options.components = Object.assign({QCard,QCardSection,QInput,QBtn,QTooltip,QSeparator,QBtnGroup,QPagination,QDialog,QFile,QIcon,QCardActions,QImg}, component.options.components || {})
component.options.directives = Object.assign({ClosePopup}, component.options.directives || {})
